import { useQuery } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

export type TrackProgress = {
  trackId: string
  userProgressPct: number
  userCompleted: boolean
  locked: boolean
  platformAvgPct: number
}

type TrainingProgressResponse = {
  tracks: TrackProgress[]
}

function getTrainingProgress(): Promise<TrainingProgressResponse> {
  return api.get(`/training/progress`)
}

export function useGetTrainingProgress() {
  return useQuery({
    queryKey: queryKeys.trainingProgress,
    queryFn: () => getTrainingProgress(),
  })
}
